import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import ChatAcquire from "../../../plugins/template/chatAcquire";
import FloatingMenu from "../../../plugins/template/floatingMenu";
import Legales from "../../../plugins/template/legales";

const GeneralTemplate = ({ enableLegales = false, enableFloatingMenu = false, enableChat = false, enableHeader = true, enableFooter = true }) => {

    return (
        <>
            {
                enableHeader && <Header />
            }
            {
                enableFloatingMenu && <FloatingMenu />
            }
            {
                enableChat && <ChatAcquire />
            }
            {
                enableLegales && (process.env.REACT_APP_ENABLE_GA4 === "true" && <Legales />)
            }
            <Outlet />
            {
                enableFooter && <Footer />
            }
        </>
    );
};

export default GeneralTemplate;